export default "__VITE_ASSET__DTVj$BR7__"